<template>
<div id="purchasable-item-search">
  <form
    method="post"
    v-on:submit.prevent="search"
  >
    <fieldset>
      <legend>Search Purchasable Items</legend>

      <div class="form-group row">
        <div class="col-1">
          <label
            for="purchasable-item-name"
            class="col-form-label"
          >
            Name
          </label>
        </div>
        <div class="col-8">
          <input
            type="text"
            name="query"
            id="query"
            class="form-control"
            v-on:keyup="search"
            v-on:blur="search"
          />
        </div>
        <div class="col-3">
          <div class="form-check">
            <label
              for="subscriptions"
              class="form-check-label col-form-label"
            >
              <input
                type="checkbox"
                name="subscriptions"
                id="subscriptions"
                class="form-check-input"
                v-on:change="search"
              />

              Subscriptions Only?
            </label>
          </div>
        </div>
      </div>
    </fieldset>

  </form>
</div>

</template>
<script>
import PurchasableItemsStore from '@/stores/PurchasableItemsStore'

import { mapState } from 'vuex'

export default {
  data () {
    return PurchasableItemsStore.state
  },

  computed: mapState({
    searchUrl () {
      return this.apiUrl('/purchasable_items/search', true)
    },
    base: state => state.base,
    foundPurchasableItems: state => state.PurchasableItemModule.found_purchasable_items
  }),

  methods: {
    search (ev) {
      /*
      // This is broken code as `sai-vue-kaminari` doesn't play well with `axios`.
      return this.$store.dispatch(
        'PurchasableItemModule/search',
        {
          query: document.getElementById('query').value,
          subscriptions: document.getElementById('subscriptions').checked
        }
      ).then((resp) => {
        this.$parent.$emit('searchComplete', {
          headers: resp.headers,
          body: {
            data: this.foundPurchasableItems
          }
        })

        return this.foundPurchasableItems
      }).catch(this.$root.processErrors)
      */

      this.$http.post(this.searchUrl, {
        query: document.getElementById('query').value,
        subscriptions: document.getElementById('subscriptions').checked
      }).then((resp) => {
        this.$parent.$emit('searchComplete', resp)
        this.purchasable_items = this.processSuccess(resp)

        // Add to our vuex store for vuex-specific components.
        this.$store.commit('PurchasableItemModule/storeFoundItems', resp)
      }, this.$root.processErrors)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PurchasableItemSearch.vue